import { render, staticRenderFns } from "./CodeOfEthics.vue?vue&type=template&id=c3e34cec&scoped=true"
import script from "./CodeOfEthics.vue?vue&type=script&lang=js"
export * from "./CodeOfEthics.vue?vue&type=script&lang=js"
import style0 from "./CodeOfEthics.vue?vue&type=style&index=0&id=c3e34cec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e34cec",
  null
  
)

export default component.exports